import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=41158fcc&scoped=true&"
import script from "./InfoBox.vue?vue&type=script&lang=ts&"
export * from "./InfoBox.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=41158fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41158fcc",
  null
  
)

export default component.exports